import { render, staticRenderFns } from "./MostVideos.vue?vue&type=template&id=0836f8d8&scoped=true&"
import script from "./MostVideos.vue?vue&type=script&lang=js&"
export * from "./MostVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0836f8d8",
  null
  
)

export default component.exports